import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslations from "./locales/en/translation.json";

i18n.use(initReactI18next).init({
    resources: {
        en: {
            translation: enTranslations,
        },
    },
    lng: "en", // Set default language
    fallbackLng: "en",
    interpolation: {
        escapeValue: false, // React handles XSS
    },
});

export default i18n;
